<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <div class="flex flex-col gap-3 lg:justify-between lg:flex-row">
      <div class="w-full self-center p-5">
        <form class="" [formGroup]="formAgendarConsulta">
          <div class="grid w-full grid-cols-1 gap-4 mb-4">
            <p><b>Modalidade:</b> {{ dadosSolicitacaoConsulta.modality | modalidadeConsulta }}</p>
            <p><b>Dias preferidos:</b> {{ dadosSolicitacaoConsulta.preferredDays }}</p>
            <p><b>Horários preferidos:</b> {{ dadosSolicitacaoConsulta.preferredTimes }}</p>
          </div>
          <div class="grid w-full gap-4" [ngClass]="{ 'grid-cols-2': isDoctor, 'grid-cols-3': !isDoctor }">
            <div class="" *ngIf="!isDoctor">
              <label for="duration" class="input-label">Atendente</label>
              <select class="form-input w-full" formControlName="doctorId">
                <option *ngFor="let doctor of doctors" [value]="doctor.id">{{ doctor.name }}</option>
              </select>
            </div>

            <div class="form-group">
              <label for="dia" class="input-label">Dia</label>
              <mat-form-field class="form-input border border-gray-500 rounded-sm">
                <input
                  matInput
                  readonly
                  [matDatepickerFilter]="filtro"
                  [matDatepicker]="picker"
                  [min]="minDate"
                  formControlName="dia"
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="duration" class="input-label">Duração consulta</label>
              <select class="form-input w-full" formControlName="duration">
                <option *ngFor="let duracao of duration" [value]="duracao.value">
                  {{ duracao.label }}
                </option>
              </select>
            </div>
          </div>
        </form>
      </div>

      <div class="flex pb-3 pt-6 pl-4 flex-col gap-2 agenda-diaria" *ngIf="viewDate">
        <span class="font-bold text-blumine text-sm"
          >Selecione o horário na Agenda para o dia: {{ viewDate | date : 'dd/MM/yyyy' }}</span
        >
        <div class="overflow-auto h-52">
          <mwl-calendar-day-view
            [viewDate]="viewDate"
            [events]="events"
            [locale]="locale"
            [hourSegments]="4"
            [dayStartHour]="8"
            [dayEndHour]="22"
            [eventTemplate]="dayView"
            [hourSegmentHeight]="35"
            style="width: 100%"
            (hourSegmentClicked)="selectTime($event)"
          >
          </mwl-calendar-day-view>
          <ng-template #dayView let-dayEvent="weekEvent">
            <app-consulta-agenda [event]="dayEvent.event"></app-consulta-agenda>
          </ng-template>
        </div>
      </div>

      <div
        class="relative flex flex-row justify-between gap-5 p-3 lg:px-5 sm:justify-start sm:gap-3 sm:flex-wrap lg:flex-col lg:justify-end bg-iceberg menu lg:h-auto sm:w-auto"
      >
        <button class="absolute w-12 h-10 rounded-sm lg:top-5 right-10 btn--secondary" routerLink="/dash/consultas">
          X
        </button>
        <button class="sm:px-2 lg:mb-5 btn w-48 btn--secondary" (click)="agendarConsulta()">Agendar Consulta</button>
      </div>
    </div>
  </div>
</div>
